module.exports = __webpack_public_path__ + "img/blue-plus.e7b6e2ec.svg";